// extracted by mini-css-extract-plugin
module.exports = {"Stats":"Stats_Stats__1dRCr"};